import React from 'react';
import { XCircle, AlertTriangle } from 'lucide-react';
import { AnimatedSection } from './ui/AnimatedSection';
const painPoints = ['Ruido nuevo en el motor que no sabés si es grave o no', 'Batería que no carga al 100% y no sabés por qué', 'Services que cobran diagnóstico sin darte respuesta clara', 'Miedo a abrir la rueda porque "puedo romper algo más"', 'Semana tras semana: algo falla, improvisás, gastás de más'];
export function PainPoints() {
  return <AnimatedSection className="py-24 relative" data-id="element-155">
      <div className="container mx-auto px-4 md:px-6" data-id="element-156">
        <div className="max-w-3xl mx-auto" data-id="element-157">
          <div className="text-center mb-12" data-id="element-158">
            <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-159">
              ¿Cuántas veces más vas a quedar a pie?
            </h2>
            <p className="text-lg text-zinc-400 mb-4" data-id="element-160">
              Querés cuidar tu monociclo. Sabés que el mantenimiento importa.
              Pero nadie te dijo que ibas a pasar horas buscando en grupos de
              Facebook en inglés, viendo videos que no aplican a tu modelo y
              pagando fortunas en services por algo que podrías resolver vos
              mismo en 45 minutos.
            </p>
            <p className="text-xl font-medium text-white bg-brand-surface inline-block px-6 py-2 rounded border border-brand-border mt-4" data-id="element-161">
              No es falta de habilidad.{' '}
              <span className="text-brand-yellow" data-id="element-162">Es falta de un sistema.</span>
            </p>
          </div>

          <div className="bg-brand-surface/50 border border-brand-border rounded-xl p-6 md:p-10 mb-12" data-id="element-163">
            <ul className="space-y-4" data-id="element-164">
              {painPoints.map((point, index) => <li key={index} className="flex items-start gap-4" data-id="element-165">
                  <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-166" />
                  <span className="text-zinc-300 text-lg" data-id="element-167">{point}</span>
                </li>)}
            </ul>
          </div>

          <div className="text-center" data-id="element-168">
            <div className="inline-flex items-center justify-center gap-3 text-2xl md:text-3xl font-heading font-bold text-white" data-id="element-169">
              <AlertTriangle className="w-8 h-8 text-brand-yellow" data-id="element-170" />
              ¿Y si esta fuera la última semana que pasás así?
            </div>
          </div>
        </div>
      </div>
    </AnimatedSection>;
}